import { Bounce, toast } from "react-toastify";
import Swal from "sweetalert2";

export function checkErrors (response , errorMessage) {
    if(response) {
        if(response.status === 401) {
            if (window.location.pathname !== "/login-page") {
                window.localStorage.removeItem("user")
                window.localStorage.removeItem("token")
                window.localStorage.removeItem("expire_date")
                window.location.pathname = "/login-page";
            }
            toast.error(
                response?.data?.message , {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });
        }else {
            if(response.data.errors && Object.keys(response.data.errors).length >= 1) {
                const errors = response.data.errors;
                for (const key in errors) {
                    if (errors.hasOwnProperty(key)) {
                        const errorMessages = errors[key];
                        errorMessages.forEach(errorMessage => {
                            toast.error(
                                errorMessage , {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                                transition: Bounce,
                            });
                        });
                    }
                }
            }else {
                Swal.fire({
                    title: "Error!",
                    text: response.data.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        }
    }else {
        Swal.fire({
            title: "Error!",
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK'
        });
    }
}